import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import PromotedStory from './promoted-story';

class Component extends BaseComponent {
    componentDidMount() {
        if (!this.props.stories) {
            this.props.requireState(this.props.limit);
        }

        this.rowLength = 2;
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.stories != this.props.stories) {
            return true;
        }

        return false;
    }

    render({ stories, mode, img_size }) {
        if (stories) {
            return (
                <promoted-content mode={mode} img_size={img_size}>
                    {this.renderHeader()}
                    {stories.map(this.renderStory).reduce(this.groupRows, []).map(this.wrapRows)}
                </promoted-content>
            );
        }

        return (<promoted-content {...this.props} />);
    }

    renderHeader = () => {
        if (this.props.mode && this.props.mode == 'sidebar') {
            return (
                <h3>
                    {this.props.title || 'The Latest'}
                    <span> FROM TAROT.COM</span>
                </h3>
            );
        }

        return (
            <header className='promoted_content_header'>
                <h2>
                    {this.props.title || 'The Latest Articles'}
                    <span> FROM TAROT.COM</span>
                </h2>
            </header>
        );
    }

    renderStory = (story, index) => (
        <column className={this.props.mode && this.props.mode == 'sidebar' ? 'is-12' : 'is-6 is-12-mobile'}>
            <PromotedStory story={story} index={index} img_size={this.props.img_size} />
        </column>
    );

    groupRows = (rows, story) => {
        if (rows.length) {
            const lastRow = rows[rows.length - 1];
            if (lastRow.length < this.rowLength) {
                lastRow.push(story);
                return rows;
            }
        }
        rows.push([story]);
        return rows;
    }

    wrapRows = (row) => (
        <row className='is-wrap'>{ row }</row>
    )
}

const mapStateToProps = (state) => ({
    stories: state.content && state.content.promoted,
});

const mapDispatchToProps = (dispatch) => ({
    requireState: (limit) => dispatch({ type: 'content:fetchPromoted', payload: limit }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
